// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:39:49

export default {
  "id": "solitaire-l-amour",
  "slug": "solitaire-l-amour",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/24dce1b06e4246f193be7115a854dba2-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/24dce1b06e4246f193be7115a854dba2/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Solitaire L'Amour",
      "description": "Love is in the air. And so is Solitaire! Enter an enchanting world as you fall head over heels for this charming new Solitaire adventure!",
      "instructions": "Remove all cards from the tableau. Play any face-up card that is one higher or lower than the stock card.",
      "genres": [
        "Cards"
      ],
      "tags": [
        "klondike",
        "relaxing",
        "romance",
        "solitaire",
        "tripeaks"
      ]
    },
    "zh-CN": {
      "title": "爱情纸牌",
      "description": "空气中弥漫着爱意。单人纸牌游戏也如此！进入一个迷人的世界，你将深深地爱上这场迷人的单人纸牌冒险！",
      "instructions": "移除牌组中的所有牌。可以出一张与底牌高或低一格的正面朝上的牌。",
      "genres": [
        "卡片"
      ],
      "tags": [
        "克拉迪克",
        "轻松",
        "浪漫",
        "单人纸牌游戏",
        "三峰"
      ]
    },
    "zh-TW": {
      "title": "單人愛情牌局",
      "description": "愛意滿滿，薩克牌也同樣如此！隨著你深陷於這迷人的新薩克牌冒險，進入一個令人著迷的世界！",
      "instructions": "從牌組中移除所有卡片。可播放任何一張面朝上的卡片，其點數比牌堆上的卡片高或低一點。",
      "genres": [
        "牌"
      ],
      "tags": [
        "克蘭迪克",
        "放鬆",
        "羅曼蒂克",
        "單人牌局",
        "三尖峰"
      ]
    },
    "zh-HK": {
      "title": "愛之單人牌局",
      "description": "愛意滿溢空中。單人牌九也一樣！隨著你對這款迷人的新單人牌九冒險熱愛不已，進入一個迷人的世界！",
      "instructions": "清空牌盤所有卡片。可出任何一張面朝上、牌面數量比牌庫中的牌多一或少一的卡片。",
      "genres": [
        "牌"
      ],
      "tags": [
        "克倫地克",
        "輕鬆",
        "羅曼蒂克",
        "獨佔",
        "三角峰"
      ]
    },
    "ja": {
      "title": "ソリタール・ラ・アモール",
      "description": "愛が空気中に漂っています。そして、ソリタリエも！この魅力的な新しいソリタリエアドベンチャーに夢中になる中で、魔法の世界に飛び込みましょう！",
      "instructions": "テーブルのカードをすべて取り除く。ストックカードの1枚高いまたは低い裏返しのカードを選んでプレイする。",
      "genres": [
        "カード"
      ],
      "tags": [
        "クロondeke",
        "リラックス",
        "ロマンス",
        "ソリタリー",
        "トリピークス"
      ]
    },
    "ko": {
      "title": "솔라이터 란무르",
      "description": "빛나는 사랑이 공기에 가득 차 있습니다. 그리고 소리빛! 이 마법 같은 새로운 소리빛 모험에的头을 숙이고 들어가세요!",
      "instructions": "테이블에서 모든 카드를 제거합니다. 스타ック 카드보다 하나 높거나 낮은 앞면을 위한 카드를 플레이하세요.",
      "genres": [
        "카드"
      ],
      "tags": [
        "클론디케",
        "쉬운",
        "로맨스",
        "솔리테어",
        "트라이피크스"
      ]
    },
    "fr": {
      "title": "Solitaire L'Amour",
      "description": "L'amour est dans l'air. Et c'est aussi le cas du Solitaire ! Plongez dans un monde enchanté alors que vous tombez amoureux de cette nouvelle aventure charmante de Solitaire !",
      "instructions": "Retirer toutes les cartes du tableau. Jouez toute carte face visible qui est d'un rang supérieur ou inférieur à la carte de la pioche.",
      "genres": [
        "Cartes"
      ],
      "tags": [
        "Klondike",
        "relaxant",
        "romance",
        "solitaire",
        "Tripeaks"
      ]
    }
  }
};
